if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.submitButton.classList.contains('js-fake-bis-trigger')) {
          const backInStockModal = document.querySelector('back-in-stock-modal');
          if (backInStockModal && typeof backInStockModal.open === 'function') {
            backInStockModal.open(this.submitButton);
            return;
          }

          const klaviyoTrigger = document.querySelector('#klaviyo-bis-button-container button');
          if (klaviyoTrigger) {
            klaviyoTrigger.click();
            return;
          }
        }

        // Gift pack: ask for a gift first (resolves null when no gift applies or the popup is closed).
        if (window.giftPicker && typeof window.giftPicker.request === 'function') {
          this.submitButton.setAttribute('aria-disabled', true);
          window.giftPicker
            .request(this)
            .catch(() => null)
            .then((giftVariantId) => {
              this.submitButton.removeAttribute('aria-disabled');
              this.addToCart(evt, giftVariantId);
            });
          return;
        }

        this.addToCart(evt, null);
      }

      addToCart(evt, giftVariantId = null) {
        let retryWithoutGift = false;
        // Re-read the cart drawer in case it was replaced since page load (e.g. by an app).
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer') || this.cart;
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const variantId = new FormData(this.form).get('id');
        const formData = giftVariantId ? this.buildGiftFormData(giftVariantId) : new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status && giftVariantId) {
              // The gift couldn't be added (e.g. it just sold out): add the product on its own.
              retryWithoutGift = true;
              return;
            }
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              //window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
            if (retryWithoutGift) this.addToCart(evt, null);
          });
      }

      // Gift pack: product + chosen gift in one request.
      buildGiftFormData(giftVariantId) {
        const source = new FormData(this.form);
        const formData = new FormData();
        let hasQuantity = false;

        for (const [key, value] of source.entries()) {
          if (key === 'id' || key === 'quantity' || key === 'selling_plan') {
            if (key === 'quantity') hasQuantity = true;
            formData.append(`items[0][${key}]`, value);
          } else if (key.startsWith('properties[')) {
            formData.append(`items[0][properties]${key.slice('properties'.length)}`, value);
          }
        }
        if (!hasQuantity) formData.append('items[0][quantity]', 1);

        formData.append('items[1][id]', giftVariantId);
        formData.append('items[1][quantity]', 1);
        formData.append('items[1][properties][_gift]', 'true');
        return formData;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
